const FETCH_AVAILABLE_PURCHASE_ITEMS_REQUEST =
  'FETCH_AVAILABLE_PURCHASE_ITEMS_REQUEST';
const FETCH_AVAILABLE_PURCHASE_ITEMS_SUCCESS =
  'FETCH_AVAILABLE_PURCHASE_ITEMS_SUCCESS';
const FETCH_AVAILABLE_PURCHASE_ITEMS_FAILURE =
  'FETCH_AVAILABLE_PURCHASE_ITEMS_FAILURE';

export default {
  FETCH_AVAILABLE_PURCHASE_ITEMS_REQUEST,
  FETCH_AVAILABLE_PURCHASE_ITEMS_SUCCESS,
  FETCH_AVAILABLE_PURCHASE_ITEMS_FAILURE,
};
